import { FunctionComponent, memo } from "react";
import { Field, Form, Formik } from "formik";
import { SubmitOnChange } from "@edgetier/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-solid-svg-icons";

import { IProps, IUsersSubscribedFilters } from "./users-subscribed-filters.types";
import "./users-subscribed-filters.scss";

/**
 * Filters for users subscribed table.
 * @param props.onSubmit A function that runs when the filters are submitted.
 */
const UsersSubscribedFilters: FunctionComponent<IProps> = ({ onSubmit }) => {
    return (
        <Formik<IUsersSubscribedFilters> onSubmit={onSubmit} initialValues={{ search: "" }}>
            <Form className="users-subscribed-filters" name="users-subscribed-filters">
                <div className="field field-inline">
                    <div className="field-inline__icon">
                        <FontAwesomeIcon icon={faSearch} />
                    </div>
                    <Field autoComplete="off" name="search" placeholder="Search users&hellip;" type="text" />
                </div>
                <SubmitOnChange />
            </Form>
        </Formik>
    );
};

export default memo(UsersSubscribedFilters);
